import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container mt-6',
    breadcrumbs: 'mb-8',
    card: 'bg-blue-light mb-12 flex flex-col items-center gap-6 rounded-[20px] p-6 lg:flex-row lg:gap-8 lg:px-15 lg:py-10',
    content:
      'flex w-full flex-col items-start justify-between gap-6 lg:flex-row lg:gap-15',
    photo:
      'max-h-37 min-h-37 max-w-37 min-w-37 overflow-hidden rounded-full border-[3px] border-white lg:min-h-49 lg:min-w-49',
    photoIcon: 'max-h-37 max-w-37 lg:min-h-49 lg:min-w-49',
    info: '',
    name: 'heading-m-bold mb-1',
    subtitle: 'heading-s mb-2',
    experience: 'heading-xs text-secondary-hover',
    socials: 'text-blue flex items-center gap-6',
    labels: 'mb-4 flex flex-wrap gap-1',
    label:
      'bg-blue flex-center text-bold flex h-6 rounded-[100px] px-2.5 text-[12px] leading-[1.2] tracking-[0.045em] text-white uppercase',

    tabs: 'mb-8 w-fit lg:ml-25',
    tab: 'h-10 w-42.5 normal-case lg:w-53.5',

    title: 'heading-3xl',
    bio: 'heading-m [&_h2]:heading-m-bold [&_h3]:heading-m-bold [&_ul]:heading-m mb-2 flex flex-col gap-4 lg:ml-25 [&_a]:underline [&_a]:underline-offset-5 [&_h2]:mb-4 [&_h3]:mb-4 [&_li]:relative [&_li]:before:absolute [&_li]:before:top-[0.7em] [&_li]:before:-left-4 [&_li]:before:h-[3px] [&_li]:before:w-[3px] [&_li]:before:rounded-full [&_li]:before:bg-current [&_ul]:ml-4 [&_ul]:pl-3',
    bioContent: 'max-w-237',

    articles: 'my-20 max-sm:mt-12 max-sm:mb-15'
  }
});
